import React, { useEffect, useState } from "react";
import CreativeCreation from "./CreativeCreation";
import { SlDrawer, SlOption, SlSelect, SlInput, SlButton, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Select from "react-select";
import config from "../../config";
import Paginator from "../../shared/Paginator";
import { formatDateWithTime } from "../../utils/dateFormat";
import { Modal } from "react-bootstrap";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import PreviewFrameEdit from "../PreviewFrameEdit";
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from "../../utils/Debounce";
import {SetComponentId } from '../../redux/counterSlice'
import { creativeTypeOps, iconMap, roles, types } from "../../utils/constants";
// import { SlButton, SlDrawer } from '@shoelace-style/shoelace/dist/react';
import FilterSvg from '../../assets/images/filter.svg'
import './CreativeList.scss'


const initial_state = [];
export const CreativeContext = React.createContext();

function AddCreative() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(6))
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  const statuses = [
    {
      value: "all",
      label: "All",
    },
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Inactive",
      label: "Inactive",
    },
  ];
  const [loader, setLoader] = useState(false);
  const [editdata, setEditData] = useState(initial_state);
  const [flag, setFlag] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [preview, setPreview] = useState({});
  const [showLogs, setShowLogs] = useState(false);
  const [logData, setLogData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const role = localStorage.getItem("role");

    if (role !== roles.ops) navigate("/pagenotfound");
  });
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const [show, setShow] = useState(false);
  const [createdEdited, setCreatedEdited] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [showFilter, setShowFilter] = useState(false)
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const [data, setData] = useState([]);
  const HeaderSearch = useSelector(state => state.Head.adssearch)

  const loadData = async (
    searchString = "",
    page = 0,
    status = "all",
    type = "all"
  ) => {
    setLoader(true);
    let obj = {
      search: searchString,
      sub_type: type,
      status,
    };
    try {
      const response = await api({
        url: `/creatives/getCreatives`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: obj,
        },
      });
      setData(response.data.data);
      setTotalPages(Math.ceil(response.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error.response.status === 401) navigate("/");
    }
  };
  const handleClone = async (creative_id,creative_name) => {
    try {
      const response = await api({
        url: `/creatives/cloneCreative`,
        method: "POST",
        responseType: "json",
        data: {
          creative_id: creative_id,
          creative_name: creative_name,
        },
      });
     loadData(search, currentPage, status, type);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/");
      }
      console.error("Error cloning creative:", error);
    }
  };
  const handlePreview = () => {
    setShowPreview(!showPreview);
  };
  const handlePreviewdata = (item) => {
    if (item) setPreview(item);
  };
  useEffect(() => {
    handlePreviewdata();
  }, [preview]);

  useEffect(() => {
    if (show === false) {
      setEditData([]);
      if (createdEdited) {
        loadData(search, currentPage, status, type);
        setCreatedEdited(false);
      }
    }
  }, [show]);

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  useEffect(() => {
    loadData(search, currentPage, status, type);
  }, [currentPage]);

  const handleshow = (data) => {
    setShow(data);
  };

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0, status, type);
  }
  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0, status, type);
  };
  const changeSelectOptionHandler = (event) => {
    setType(event.target.value);
    setCurrentPage(0);
    loadData(search, 0, status, event.target.value);
  };
  const changeSelectHandler = (event) => {
    setStatus(event.target.value);
    setCurrentPage(0);
    loadData(search, 0, event.target.value, type);
  };
  const sortLogs = (logs) => {
    if (!logs || Object.keys(logs).length === 0) {
      return {}; // Return an empty object if no logs are present
    }
    // Convert the object to an array of [key, value] pairs
    const sortedEntries = Object.entries(logs)
      .sort((a, b) => {
        // Extract the numbers after the "-" in the key
        const numA = a[0].split('-')[1];
        const numB = b[0].split('-')[1];
        return numB - numA;  // Sorting by ascending number
      });

    // Convert the sorted array back into an object or keep it as an array
    return Object.fromEntries(sortedEntries);
  };


function renderAdType(subType) {
  const type = iconMap[subType] || iconMap["default"]; // Fallback to default if not found
  return (
    <div>
      <sl-icon name={type.icon} library={type.library || "default"}></sl-icon>
      <span className="ml-2">{type.label}</span>
    </div>
  );
}

// Example usage

  return (
    <>
      <div className="creativeListPage">
        <div className="cl-card">
          <header className="cl-header">
            <div className="cl-title-block">
              <h1 className="cl-title">Creative List</h1>
              <p className="cl-subtitle">Manage and preview all your ad creatives</p>
            </div>

            {/* desktop toolbar */}
            <div className="cl-toolbar">
              <SlInput
                className="cl-search"
                size="medium"
                id="myInput"
                onSlInput={debounce(searchData, 500)}
                placeholder="Search By Creative Name">
                <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
              </SlInput>
              <SlSelect
                size="medium"
                className="cl-select"
                style={{ width: "260px" }}
                placeholder="Select Type"
                defaultValue={type}
                onSlChange={changeSelectOptionHandler}>
                <SlIcon library="lucide" name="image" slot="prefix"></SlIcon>
                {types.map((option) => (
                  <SlOption key={option.value} value={option.value}>
                    {option.label}
                  </SlOption>
                ))}
              </SlSelect>
              <SlButton
                variant="primary"
                size="medium"
                value={show}
                onClick={() => {
                  setFlag("add");
                  setSearch("");
                  handleshow(true);
                }}>
                <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
                Add Creative
              </SlButton>
            </div>

            {/* mobile toolbar */}
            <div className="cl-toolbar-mobile">
              <button type="button" className="cl-filter-btn" onClick={() => setShowFilter(true)}>
                <img src={FilterSvg} alt="filter" />
              </button>
              <SlButton
                variant="primary"
                size="medium"
                value={show}
                onClick={() => {
                  setFlag("add");
                  setSearch("");
                  handleshow(true);
                }}>
                <SlIcon library="lucide" name="plus" slot="prefix"></SlIcon>
                Add Creative
              </SlButton>
            </div>
          </header>

          <div className="cl-table-wrap">
            <table className="cl-table">
              <thead>
                <tr>
                  <th>Creative Name</th>
                  <th>Created Date</th>
                  <th>Creative Type</th>
                  <th>Sub Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {data?.length && !loader ? (
                <tbody>
                  {data.map((item) => {
                    return (
                      <tr key={item.creative_id}>
                        <td className="cl-name" data-label="Creative Name">{item.name}</td>
                        <td data-label="Created Date">{formatDateWithTime(item.created_date)}</td>
                        <td data-label="Creative Type">{creativeTypeOps.find(j => j.value === item.creative_type)?.label}</td>
                        <td data-label="Sub Type">
                          <span className="cl-subtype">{renderAdType(item.sub_type)}</span>
                        </td>
                        <td data-label="Actions">
                          <div className="cl-actions">
                            <sl-tooltip content="Preview Creative">
                              <sl-icon-button
                                library="lucide"
                                name="view"
                                onClick={() => { handlePreview(); handlePreviewdata(item); }}></sl-icon-button>
                            </sl-tooltip>
                            <sl-tooltip content="Edit Creative">
                              <sl-icon-button
                                library="lucide"
                                name="edit"
                                onClick={() => { setFlag("edit"); setEditData(item); handleshow(true); }}></sl-icon-button>
                            </sl-tooltip>
                            <sl-tooltip content="Clone Creative">
                              <sl-icon-button
                                library="lucide"
                                name="files"
                                onClick={() => handleClone(item.creative_id, item.name)}></sl-icon-button>
                            </sl-tooltip>
                            <sl-tooltip content="Logs">
                              <sl-icon-button
                                library="lucide"
                                name="terminal-square"
                                onClick={() => { setShowLogs(true); setLogData(sortLogs(item.logs)) }}></sl-icon-button>
                            </sl-tooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : !data?.length && !loader ? (
                <NoDataFound colspan="5" />
              ) : (
                <TableLoader colspan="5" />
              )}
            </table>
          </div>
        </div>
        {totalPages > 1 && (
          <div className="cl-pagination">
            <Paginator
              pageCount={totalPages}
              handlePageClick={handlePageClick}
              forcePage={currentPage}
            />
          </div>
        )}
      </div>
      <section className="creativeAdd">
        {show && (
          <CreativeCreation
            handleshow={handleshow}
            editdata={editdata}
            flag={flag}
            createdEdited={setCreatedEdited}
          ></CreativeCreation>
        )}
      </section>
      <SlDrawer label="Preview" open={showPreview} onSlAfterHide={handlePreview}>
        <CreativeContext.Provider value={{ preview, setPreview }}>
          <PreviewFrameEdit showPreview={showPreview} />
        </CreativeContext.Provider>
      </SlDrawer>
      {/* <Modal show={showPreview} onHide={handlePreview}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreativeContext.Provider value={{ preview, setPreview }}>
            <PreviewFrameEdit />
          </CreativeContext.Provider>
        </Modal.Body>
      </Modal> */}
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="flex items-center ml-auto gap-3 flex-wrap">
          <div className="w-full">
            <SlInput
              size="medium"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search By Creative Name">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            {/* <input
              className="form-control"
              type="text"
              id="myInput"
              onChange={debounce(searchData, 500)}
              placeholder="Search By Creative Name"
            /> */}
          </div>
          <div className="w-full">
            <SlSelect
              size="medium"
              placeholder="Select Type"
              defaultValue={type}
              onSlChange={changeSelectOptionHandler}>
              <SlIcon library="lucide" name="image" slot="prefix"></SlIcon>
              {types.slice(0, 11).map((option) => (
                <SlOption key={option.value} value={option.value}>
                  {option.label}
                </SlOption>
              ))}
            </SlSelect>
            {/* <Select
              placeholder="Select Type"
              defaultValue={type}
              options={types}
              onChange={changeSelectOptionHandler}
            ></Select> */}
          </div>
        </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
      <SlDrawer
        open={showLogs}
        onSlRequestClose={handleRequestClose}
        label="Logs"
        onSlAfterHide={()=>{setShowLogs(false);setLogData([])}}
        style={{ "--size": `${window.innerWidth <= 767 ? "100vw" : "60vw"}` }}
      >
        <>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Field</th>
              <th>Previous</th>
              <th>Updated</th>
              <th>Updated By</th>
              <th>Updated At</th>
            </tr>
          </thead>
          {logData && Object.keys(logData).length > 0 ? <tbody>
            {Object.keys(logData).map((item) => {
              const field = item?.split("-")[0];
              const from_value = logData[item]?.from;
              const to_value = logData[item]?.to;
              const user_name = logData[item]?.user_name;
              const updated_at = logData[item]?.date;
              return (
                <tr key={item}>
                  <td>{field}</td>
                  <td>{from_value || "-"}</td>
                  <td>{to_value || "-"}</td>
                  <td>{user_name}</td>
                  <td>{formatDateWithTime(updated_at) || "-"}</td>
                </tr>
              );
            })}
          </tbody> : <NoDataFound colspan="5" />}
        </table>
        </>
      </SlDrawer>
    </>
  );
}
export default AddCreative;
